<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
    Mypage Top Main -sol
========================================================================================== -->

<!-- ExamMain 시험 메인 화면 -->
<template>
<div class="layout-top-main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
  <!-- <vx-tour :steps="steps" v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" /> -->

  <!-- <v-nav-menu :navMenuItems="navMenuItems" title="FilledU" parent=".layout--main" /> -->
  <!-- <etest-sidebar
    v-if                    = "!disableCustomizer"
    :footerType             = "footerType"
    :hideScrollToTop        = "hideScrollToTop"
    :navbarType             = "navbarType"
    :navbarColor            = "navbarColor"ZZZ
    :routerTransition       = "routerTransition"
    @toggleHideScrollToTop  = "toggleHideScrollToTop" /> -->


  <!-- <vs-navbar collapse v-model="activeItem" class="p-2" @click="test()"> -->
  <exam-top/>

  <transition :name="routerTransition" mode="out-in">
    <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
  </transition>

</div>
</template>

<script>
import EtestSidebar from "@/layouts/components/customizer/EtestSidebar.vue"
import themeConfig from '@/../themeConfig.js'
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import ExamTop from "@/layouts/components/ExamTop.vue"


export default {
  data() {
    return {
      active: false,
      ExamNumList: [],
      navMenuItems: navMenuItems,
      // navActiveItem: 0,
      checkBox1: true,
      checkBox2: true,
      val: '',
      value1: '',
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      questionInfo: {
        'index': 0,
        'exam_subject_id': 0,
        'title': '',
        'question_info': '',
        'question_type': 1,
        'answer': '',
        'score': 1,
        'answer_multiple':[],
        'answer_number': 0
      },
    }
  },
  components: {
    EtestSidebar,
    HNavMenu,
    ExamTop,
  },

  computed: {
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark'
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
    },
  },
  methods: {
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    move() {
      this.$router.back()
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
  },
  created() {
    for (var i = 1; i <= 50; i++) {
      this.ExamNumList.push(i)
    }
    // this.$store.dispatch('etest/getEtestQuestion', this.activeSubject.id).then(()=>{
    //   this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[this.questionList.length-1])
    // })
  }
}
</script>

<style lang="scss">
.header-sidebar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    h4 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        > button {
            margin-left: 10px;
        }
    }
}

.footer-sidebar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    > button {
        border: 0 solid rgba(0, 0, 0, 0) !important;
        border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
        border-radius: 0 !important;
    }
}

#theme-customizer {
    .vs-sidebar {
        position: fixed;
        z-index: 52000;
        width: 400px;
        max-width: 90vw;
        // @apply shadow-lg;
        box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
}

.customizer-btn {
    position: fixed;
    top: 50%;
    right: 0;
    // border-top-right-radius: 0;
    // border-bottom-right-radius: 0;
    z-index: 50000;

    // .vs-icon {
    //   animation: spin 1.5s linear infinite;
    // }
}

.scroll-area--customizer {
    height: calc(100% - 5rem);

    &:not(.ps) {
        overflow-y: auto;
    }
}
</style>
